import { render, staticRenderFns } from "./PakhshMuyragi.vue?vue&type=template&id=6466a456"
import script from "./PakhshMuyragi.vue?vue&type=script&lang=js"
export * from "./PakhshMuyragi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports